import styled from 'styled-components';

import {
  blackSphera,
  grayLightSphera,
  grayPlaceholder,
  greenSp,
  graySphera,
  whiteSphera
} from 'src/utilities/UIStyles/variables/Colors';

export const HomeContainer = styled.section``;

export const Main = styled.main`
  display: flex;

  > div {
    width: 40%;
    margin-left: 5%;
    padding-top: 10%;

    > h2 {
      color: ${blackSphera};
      font-size: 4vw;

      > span {
        color: ${greenSp};
      }
    }

    > p {
      color: ${blackSphera};
      font-size: 1.5vw;
      width: 85%;
    }
  }

  > figure {
    width: 60%;

    > img {
      width: 100%;
      height: auto;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > h2 {
        > span {
        }
      }

      > p {
      }
    }

    > figure {
      > img {
      }
    }
  }

  @media (max-width: 600px) {
    padding-bottom: 10%;

    > div {
      > h2 {
        font-size: 10vw;

        > span {
        }
      }

      > p {
        font-size: 5vw;
        width: 95%;
      }
    }

    > figure {
      > img {
      }
    }
  }
`;

export const InvestUs = styled.section`
  background-color: ${whiteSphera};
  height: auto;
  padding-top: 5%;
  padding-bottom: 2.5%;

  > div {
    display: flex;
    width: 90%;
    margin: auto;

    > div {
      width: 33%;

      > figure {
        text-align: center;
        width: 150px;
        height: 150px;
        margin: 0 auto 2.5% auto;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      > h3 {
        color: ${blackSphera};
        text-align: center;
        font-size: 1.4vw;
        font-weight: bold;
      }

      > p {
        color: ${blackSphera};
        text-align: center;
        font-size: 1.4vw;
        width: 70%;
        margin: 2.5% auto 0 auto;
      }
    }
  }

  > p {
    color: ${blackSphera};
    font-size: 1.3vw;
    text-align: center;
    width: 80%;
    margin: 2.5% auto;
  }

  > a {
    display: block;
    color: ${whiteSphera};
    font-weight: bold;
    font-size: 1.2vw;
    text-decoration: none;
    text-align: center;
    line-height: 50px;
    width: 400px;
    height: 50px;
    margin: 2.5% auto;
    border-radius: 5px;
    background-color: ${blackSphera};
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > div {
        > figure {
          img {
          }
        }

        > p {
        }
      }
    }

    > p {
    }

    > a {
    }
  }

  @media (max-width: 600px) {
    > div {
      flex-direction: column;

      > div {
        width: 100%;

        > figure {
          width: 120px;
          height: 120px;

          img {
          }
        }

        > p {
          font-size: 4.3vw;
          margin: 2.5% auto 8% auto;
        }
      }
    }

    > p {
      font-size: 4.2vw;
      width: 90%;
    }

    > a {
      font-size: 4.2vw;
      width: 90%;
      margin: 5% auto;
    }
  }
`;

export const CalculateCredit = styled.section`
  background-color: #e7fd4f;
  padding: 2.5% 0;

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    padding-top: 5%;
    padding-bottom: 10%;
  }
`;

export const CalculateCreditTitle = styled.div`
  > h2 {
    color: ${blackSphera};
    font-size: 3vw;
    text-align: center;
  }

  > p {
    color: ${blackSphera};
    font-size: 1.5vw;
    font-weight: bold;
    text-align: center;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > h2 {
    }

    > p {
    }
  }

  @media (max-width: 600px) {
    > h2 {
      font-size: 6vw;
    }

    > p {
      font-size: 4.5vw;
    }
  }
`;

export const CalculateCreditContainer = styled.div`
  display: flex;
  width: 80%;
  margin: 5% auto 4% auto;
  padding: 2.5%;
  border-radius: 10px;
  background-color: ${whiteSphera};

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    flex-direction: column;
    width: 90%;
  }
`;

export const CalculateCreditContainerForm = styled.div`
  width: 50%;

  > p {
    color: ${blackSphera};
    font-size: 1.2vw;
    width: 55%;
    margin-bottom: 5%;
  }

  > div:nth-child(2),
  > div:nth-child(5) {
    display: flex;
    justify-content: space-between;
    width: 80%;
  }

  > div {
    margin-top: 2.5%;

    > p:nth-child(1) {
      color: ${graySphera};
      font-size: 1.2vw;
      font-weight: bold;
      margin-bottom: 1%;
    }

    > p:nth-child(2) {
      color: ${graySphera};
      font-size: 1.2vw;
      margin-bottom: 1%;
    }

    > div {
      display: flex;
      justify-content: start;
      align-items: center;

      > input {
        font-size: 1.2vw;
        color: ${grayPlaceholder};
        width: 70%;
        height: 35px;
        margin-right: 2%;
        padding-left: 2.5%;
        border: 1px solid ${grayLightSphera};
        border-radius: 5px;
        accent-color: ${blackSphera};

        &::placeholder {
          color: ${grayPlaceholder};
        }
      }

      > p {
        color: ${graySphera};
        font-size: 1.2vw;
        margin-bottom: 1%;
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > p {
    }

    > div {
      > p {
      }

      > div {
        > select {
        }

        > input {
          &::placeholder {
          }
        }

        > figure {
          > img {
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    width: 100%;

    > p {
      font-size: 4.2vw;
      width: 100%;
    }

    > div {
      > p:nth-child(1) {
        color: ${graySphera};
        font-size: 4.2vw;
        font-weight: bold;
        margin-bottom: 1%;
      }

      > p:nth-child(2) {
        color: ${graySphera};
        font-size: 4.2vw;
        margin-bottom: 1%;
      }

      > div {
        display: flex;

        p {
          font-size: 4.2vw;
        }

        > select {
          font-size: 4.2vw;
          width: 100%;
        }

        > input {
          font-size: 4.2vw;
          width: 65%;

          &::placeholder {
          }
        }

        > figure {
          width: 30px;
          height: 30px;
          cursor: pointer;

          > img {
          }
        }
      }
    }
  }
`;

export const CalculateCreditContainerResults = styled.div`
  width: 50%;

  > p:nth-child(1) {
    color: ${blackSphera};
    font-size: 1.2vw;
    width: 90%;
    margin-bottom: 5%;
  }

  > div:nth-child(2) {
    > div:nth-child(1) {
      display: flex;
      justify-content: space-between;
      margin-bottom: 2.5%;

      > h3 {
        color: ${blackSphera};
        font-size: 1.2vw;
        width: 33%;
      }
    }

    > div:nth-child(5),
    > div:nth-child(6),
    > div:nth-child(7),
    > div:nth-child(8),
    > div:nth-child(9) {
      display: flex;
      justify-content: space-between;
      width: 90%;
      margin-bottom: 2.5%;

      > p {
        color: ${blackSphera};
        font-size: 1.1vw;
        width: 33%;
      }
    }

    > div:nth-child(2),
    > div:nth-child(3),
    > div:nth-child(4) {
      display: flex;
      justify-content: space-between;
      width: 90%;
      margin-bottom: 2.5%;

      > p {
        color: ${blackSphera};
        font-size: 1.1vw;
        font-weight: bold;
        width: 33%;
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > p:nth-child(1) {
    }

    > div:nth-child(2) {
      > div:nth-child(1) {
        > h3 {
        }
      }

      > div:nth-child(5),
      > div:nth-child(6),
      > div:nth-child(7),
      > div:nth-child(8),
      > div:nth-child(9) {
        > p {
        }
      }

      > div:nth-child(2),
      > div:nth-child(3),
      > div:nth-child(4) {
        > p {
        }
      }
    }
  }

  @media (max-width: 600px) {
    width: 100%;

    > p:nth-child(1) {
      font-size: 4.2vw;
      width: 100%;
      margin-top: 10%;
    }

    > div:nth-child(2) {
      > div:nth-child(1) {
        width: 100%;
        margin-bottom: 5%;

        > h3 {
          font-size: 4vw;
        }
      }

      > div:nth-child(5),
      > div:nth-child(6),
      > div:nth-child(7),
      > div:nth-child(8),
      > div:nth-child(9) {
        width: 100%;

        > p {
          font-size: 3.8vw;
        }
      }

      > div:nth-child(2),
      > div:nth-child(3),
      > div:nth-child(4) {
        width: 100%;
        margin-bottom: 5%;

        > p {
          font-size: 3.8vw;
        }
      }
    }
  }
`;

export const CalculateCreditButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  > a {
    display: block;
    color: ${whiteSphera};
    font-weight: bold;
    font-size: 1.5vw;
    text-decoration: none;
    text-align: center;
    line-height: 50px;
    width: 30%;
    height: 50px;
    border-radius: 5px;
    background-color: ${blackSphera};
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > a {
    }
  }

  @media (max-width: 600px) {
    > a {
      font-size: 4.5vw;
      width: 90%;
    }
  }
`;

export const CalculateCreditAdvices = styled.ul`
  list-style: none;
  width: 80%;
  margin: 2.5% auto 0 auto;

  > li {
    font-size: 1.2vw;
    color: ${blackSphera};
    margin-bottom: 0.5%;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > li {
    }
  }

  @media (max-width: 600px) {
    width: 90%;
    margin: 5% auto 0 auto;

    > li {
      font-size: 4.2vw;
      margin-bottom: 2.5%;
    }
  }
`;

export const OurServices = styled.section`
  display: flex;
  height: 600px;

  > div:nth-child(1) {
    width: 50%;
    background-color: ${blackSphera};
    padding: 2.5% 5% 2.5% 5%;

    > h2:nth-child(1) {
      color: ${whiteSphera};
      font-size: 3vw;
      margin-bottom: 5%;

      > span {
        color: ${greenSp};
      }
    }

    > p:nth-child(2),
    > p:nth-child(3) {
      color: ${whiteSphera};
      font-size: 1.2vw;
    }

    > a:nth-child(4) {
      display: block;
      color: ${blackSphera};
      font-size: 1.2vw;
      font-weight: bold;
      text-decoration: none;
      text-align: center;
      line-height: 40px;
      width: 50%;
      height: 40px;
      margin-top: 5%;
      margin-bottom: 5%;
      border-radius: 5px;
      background-color: ${whiteSphera};
    }

    > p:nth-child(5) {
      color: ${whiteSphera};
      font-size: 1.5vw;
    }
  }

  > figure {
    width: 50%;
    height: auto;

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1) {
      > h2:nth-child(1) {
        > span {
        }
      }

      > p:nth-child(2),
      > p:nth-child(3) {
      }

      > a:nth-child(4) {
      }

      > p:nth-child(5) {
      }
    }

    > figure {
      > img {
      }
    }
  }

  @media (max-width: 600px) {
    flex-direction: column;

    > div:nth-child(1) {
      width: 100%;
      padding: 5% 5% 5% 5%;

      > h2:nth-child(1) {
        font-size: 10vw;

        > span {
        }
      }

      > p:nth-child(2),
      > p:nth-child(3) {
        font-size: 4.2vw;
      }

      > a:nth-child(4) {
        font-size: 4.2vw;
        width: 100%;
        margin-top: 5%;
      }

      > p:nth-child(5) {
        font-size: 4.2vw;
      }
    }

    > figure {
      width: 100%;

      > img {
      }
    }
  }
`;

export const Benefits = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: rgb(245, 245, 245);

  > div:nth-child(1) {
    > div:nth-child(1) {
      > figure {
        transform: ${(props) => (props.showBenefits ? 'rotate(90deg)' : 'rotate(270deg)')};
      }
    }

    > div:nth-child(2) {
      transform: ${(props) => (props.showBenefits ? 'scaleY(1)' : 'scaleY(0)')};
    }
  }

  > div:nth-child(2) {
    > div:nth-child(1) {
      > figure {
        transform: ${(props) => (props.showDifferences ? 'rotate(90deg)' : 'rotate(270deg)')};
      }
    }

    > div:nth-child(2) {
      transform: ${(props) => (props.showDifferences ? 'scaleY(1)' : 'scaleY(0)')};
    }
  }

  > div:nth-child(1),
  > div:nth-child(2) {
    width: 40%;
    margin: 5% auto;
    border-radius: 5px;

    > div:nth-child(1) {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 3.5% 5%;
      background-color: ${whiteSphera};
      -webkit-box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
      box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);

      > h3 {
        font-size: 1.2vw;
        font-weight: normal;
        color: ${graySphera};
      }

      > figure {
        width: 15px;
        height: 25px;
        transition: all 0.25s linear;
        cursor: pointer;

        > img {
          width: 100%;
          height: 100%;
        }
      }
    }

    > div:nth-child(2) {
      background-color: ${whiteSphera};
      transition: all 0.25s linear;
      transform-origin: top left;
      z-index: 10;
      position: relative;

      > ul {
        padding: 5% 0 5% 10%;

        > li {
          font-size: 1.2vw;
          color: ${graySphera};
          margin-bottom: 1%;
          width: 65%;
        }
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1),
    > div:nth-child(2) {
      > div:nth-child(1) {
        > h3 {
        }

        > figure {
          > img {
          }
        }
      }

      > div:nth-child(2) {
        > ul {
          > li {
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    flex-direction: column;

    > div:nth-child(1),
    > div:nth-child(2) {
      width: 90%;

      > div:nth-child(1) {
        > h3 {
          font-size: 4.2vw;
        }

        > figure {
          > img {
          }
        }
      }

      > div:nth-child(2) {
        > ul {
          > li {
            font-size: 4.2vw;
            margin-bottom: 2.5%;
            width: 100%;
          }
        }
      }
    }
  }
`;
